import * as $ from 'jquery';

export class SubmittableFilter {
  public static readyToBeSubmittedClass = 'js_filter_ready_to_be_submitted';
  protected static readonly Selector = {};
  protected static applyReadyToBeSubmittedClass(element: JQuery<HTMLElement>) {
    element.addClass(this.readyToBeSubmittedClass);
  };

  /**
   * Unfortunate Bodzio Filters design assumes that some of the filters are present in both places
   * (above product cards and in expandable side panel). So we need some way to sync both filters
   * in order to apply proper filters, no matter where user did try to add
   */
  protected static syncSelectTypeFilterWithItsEquivalent(element: HTMLSelectElement, { targetSelector }: { targetSelector: string }) {
      let equivalent = $(targetSelector).find(`[name="${element.name}"]`);

	  // Synchronizuj wartości
	  equivalent.val($(element).val()).change();

	  // Synchronizuj atrybuty selected i disabled dla każdej opcji
	  const $sourceSelect = $(element);
	  const $targetSelect = equivalent;

	  $sourceSelect.find('option').each((index, sourceOption) => {
	    const $sourceOption = $(sourceOption);
	    const optionValue = $sourceOption.val();
	    const $targetOption = $targetSelect.find(`option[value="${optionValue}"]`);

	    if ($targetOption.length) {
	      $targetOption.prop('selected', $sourceOption.prop('selected'));
	      // Jeśli opcja jest disabled w source, zostaw ją disabled w target
	      // Jeśli nie jest disabled w source, ale jest w target, zostaw ją (może być specjalnie traktowana)
	      if ($sourceOption.prop('disabled')) {
	        $targetOption.prop('disabled', true);
	      }
	    }
	  });
	  
	  // Refresh selectrica na końcu
	  equivalent.selectric('refresh');
  }

	protected static initSelectricMinWidth() {
		$('body').on('selectric-init', function(event, element) {
			const $select = $(element);
			if ($select.data('mode-min-width') === 1) {
				requestAnimationFrame(() => { //Only the second requestAnimationFrame catches the rendered element correctly (there are no jumps)
					requestAnimationFrame(() => {
						const $wrapper = $select.closest('.selectric-wrapper');
						if ($wrapper.length) {
							const realWidth = $wrapper[0].getBoundingClientRect().width;
							$wrapper[0].style.setProperty('min-width', realWidth + 'px', 'important');
						}
					});
				});
			}
		});
	}
}
import * as $ from 'jquery';

export class SubmittableFilter {
  public static readyToBeSubmittedClass = 'js_filter_ready_to_be_submitted';
  protected static readonly Selector = {};
  protected static applyReadyToBeSubmittedClass(element: JQuery<HTMLElement>) {
    element.addClass(this.readyToBeSubmittedClass);
  };

  /**
   * Unfortunate Bodzio Filters design assumes that some of the filters are present in both places
   * (above product cards and in expandable side panel). So we need some way to sync both filters
   * in order to apply proper filters, no matter where user did try to add
   */
  protected static syncSelectTypeFilterWithItsEquivalent(element: HTMLSelectElement, { targetSelector }: { targetSelector: string }) {
      let equivalent = $(targetSelector).find(`[name="${element.name}"]`);

	  // Synchronizuj wartości
	  equivalent.val($(element).val()).change();

	  // Synchronizuj atrybuty selected i disabled dla każdej opcji
	  const $sourceSelect = $(element);
	  const $targetSelect = equivalent;

	  $sourceSelect.find('option').each((index, sourceOption) => {
	    const $sourceOption = $(sourceOption);
	    const optionValue = $sourceOption.val();
	    const $targetOption = $targetSelect.find(`option[value="${optionValue}"]`);

	    if ($targetOption.length) {
	      $targetOption.prop('selected', $sourceOption.prop('selected'));
	      // Jeśli opcja jest disabled w source, zostaw ją disabled w target
	      // Jeśli nie jest disabled w source, ale jest w target, zostaw ją (może być specjalnie traktowana)
	      if ($sourceOption.prop('disabled')) {
	        $targetOption.prop('disabled', true);
	      }
	    }
	  });
	  
	  // Refresh selectrica na końcu
	  equivalent.selectric('refresh');
  }

	protected static initSelectricMinWidth() {
		$('body').on('selectric-init', function(event, element) {
			const $select = $(element);
			if ($select.data('mode-min-width') === 1) {
				requestAnimationFrame(() => { //Only the second requestAnimationFrame catches the rendered element correctly (there are no jumps)
					requestAnimationFrame(() => {
						const $wrapper = $select.closest('.selectric-wrapper');
						if ($wrapper.length) {
							const realWidth = $wrapper[0].getBoundingClientRect().width;
							$wrapper[0].style.setProperty('min-width', realWidth + 'px', 'important');
						}
					});
				});
			}
		});
	}
}
